const urls = {
  fetchOperatorSubordinates() {
    return `/user/getOperatorSubordinates`;
  },
  deleteOperatorSubordinate(code: string) {
    return `/user/removeSubordinate?userCode=${code}`;
  },
  fetchAllRoles() {
    return `/user/getAllRoles`;
  },
  fetchAllVehicles() {
    return `/vehicle/getAll`;
  },
  fetchPermissions() {
    return `/user/permissionGroup`;
  },
  addRole() {
    return `/user/addRolePermissions`;
  },
  createRole() {
    return `/user/createRole`;
  },
  deleteRole() {
    return `/user/deleteRolePermissions`;
  },
  addUser() {
    return `/user/addSubordinate/v2`;
  },
};
export default urls;
